import React, { Component } from "react";
import PropTypes from "prop-types";
import { TitleCase } from "../../common";

class ControlTitle extends Component {
  shouldComponentUpdate(nextProps) {
    const different = this.props.text !== nextProps.text;
    return different;
  }

  render() {
    const { text, optional } = this.props;

    if (optional === false) {
      return (
        <label>
          {TitleCase(text)}
          <span className="optionalField">*</span>
        </label>
      );
    }

    return (
      <label>
        {TitleCase(text)}
        <span className="optionalField"></span>
      </label>
    );
  }
}

ControlTitle.propTypes = {
  text: PropTypes.string.isRequired,
  optional: PropTypes.bool.isRequired
};

export default ControlTitle;



// WEBPACK FOOTER //
// ./src/components/ControlTitle/index.js